<template>
    <div>
        <!--        <Word word="story"/>-->
        <Word :word="wordText" v-if="wordText"/>
    </div>
</template>

<script>
    import Word from "@/components/dictionary/oxford/Word"

    export default {
        name: 'WordOxfordView',
        components: {
            Word
        },
        props: {
            wordText: null
        },
        data: function () {
            return {}
        },
        mounted() {
            // this.wordText = this.$route.query['word']
        }
    }
</script>
